import { render, staticRenderFns } from "./ModalPoints.vue?vue&type=template&id=19e39f4e&scoped=true&"
import script from "./ModalPoints.vue?vue&type=script&lang=js&"
export * from "./ModalPoints.vue?vue&type=script&lang=js&"
import style0 from "./ModalPoints.vue?vue&type=style&index=0&id=19e39f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e39f4e",
  null
  
)

export default component.exports